import { render, staticRenderFns } from "./RetirementRequest.vue?vue&type=template&id=51c5848d&"
import script from "./RetirementRequest.vue?vue&type=script&lang=js&"
export * from "./RetirementRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports